module.exports = __webpack_public_path__ + "media/images/bachelor_degree-1c641220e3deaf23e37680bf7b9d0869.png";